import React, { ReactElement } from 'react';
import { Button } from 'idsk-react-components';

const FilterButtons = ():ReactElement => (
  <div className="filter-buttons">
    <Button
      className="filter-button"
      size="large"
      buttonStyle="action"
      type="submit"
    >
      Filtrovať
    </Button>
    <Button
      size="large"
      buttonStyle="secondary"
      type="reset"
    >
      Zrušiť kritériá
    </Button>
  </div>
);

export default FilterButtons;
